export default __webpack_public_path__ + "static/media/022-onion.d283eb10.svg";